import { FeatureToggleValue, KnownFeatureToggles } from "modules/features/models";
import { ApplicationState } from "store";

/**
 * True when member-initiated edits should be locked because the Vital Objects month-end job is
 * running. The feature toggle is ANDed in here, in one place, so turning the toggle off disables
 * the whole feature regardless of what Vital Objects reports.
 */
export const getIsMonthEndLockActive = (state: ApplicationState): boolean =>
    state?.features?.featureToggles?.[KnownFeatureToggles.EnableMonthEndMaintenanceLockout]?.toggleValue ===
        FeatureToggleValue.On && state?.maintenance?.monthEnd?.isInProgress === true;
